import type { CSSProperties, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { useInView } from '@/hooks/use-in-view'

interface RevealProps {
    children: ReactNode
    className?: string
    delay?: number
}

const Reveal: FC<RevealProps> = ({ children, className, delay = 0 }): ReactNode => {
    const [ref, inView] = useInView<HTMLDivElement>()
    const style: CSSProperties = { transitionDelay: `${delay}ms` }

    return (
        <div
            ref={ref}
            style={style}
            className={cn(
                'transition-[opacity,translate] duration-[900ms] ease-[cubic-bezier(0.2,0.7,0.2,1)] motion-reduce:translate-y-0 motion-reduce:transition-none',
                inView ? 'translate-y-0 opacity-100' : 'translate-y-6 opacity-0',
                className
            )}
        >
            {children}
        </div>
    )
}

export default Reveal
